import React, { useState, useEffect, useRef, useContext, useMemo, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import ImageComponent from 'atoms/Image/index';
import { Row, Col } from 'reactstrap';
import { InputBox } from 'atoms/InputBox';
import SearchIcon from 'styles/staticAssets/images/searchIcon.svg';
import SearchIconGrey from 'styles/staticAssets/images/searchIconGrey.svg';
import DarkCloseButton from 'styles/staticAssets/images/Darkclosebutton.svg';
import StripesIcon from 'styles/staticAssets/images/Stripes_OffersIcon.svg';
import MobSearchIcon from 'styles/staticAssets/images/mobileSearch.svg';
import NavigationItems from './NavigationItems';
import SearchItems from './SearchItems';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import {
  menuNavigationAnalyticsData,
  getAnalytictsPayloadConditionaly,
  vieItemListAnalytics,
  getCategoryAndProduct,
  closeSearchFilterMenu,
  setAnalyticsData,
  filterRecommendations,
  getCategoryFromSubCategory,
  changeMenulistOrder,
  getMenuData,
  checkItemName,
} from '../MenusPlpUtilities/MenusPlpUtils';
import { ENTER, MENU_PLP_CONSTANT } from '../MenuPLPConstants/MenuPLPConstants';
import {
  filterNotHiddenProducts,
  isEmptyObject,
  getDispositionTypeOnAPIFormat,
  isSupportedTenantCode,
  getValueOrDefaultObject,
  getValueOrnull,
  getHeaderContentData,
  getTernaryValue,
  recursiveAndCheck,
  getAndCheck,
  goToMenuPage,
  getCheckIfAnyOnePass,
  getAndCheckIfOneTrue,
  getAndCheckIfAllPass,
} from 'common/utilities/utils';
import MENUS_PLP_CONSTANTS from '../Constants/MenusPLPConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  displaySectionWhenThereAreNoMatchingProduct,
  getMenusSubcategory,
  hasSubcategory,
  getDispositionNewData,
} from '../MenusPlpUtilities/MenuPLPSharedUtils';
import MobSearchFilterMenu from './MobSearchFilterMenu';
import MenuItems from './MenuItems';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';

import getContentPlpDisclaimer from '@kfc-global/react-shared/redux/Actions/PLPDisclaimerAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { get } from 'lodash';
import PromosRewardsContainer from 'organisms/PromosRewards/Container/PromosRewardsContainer';
import { PLP_PAGE, ROUTE_URL, ACTIVITY_EVENTS } from 'common/constants/SharedConstants';
import { scroller } from 'react-scroll';
import { checkIfCateringPage } from 'common/utilities/CateringPLPUtils';
import DynamicHeadings from 'atoms/DynamicHeadings/DynamicHeadings';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';
import useStyleScripts from 'common/custom-hooks/useStyleScripts';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const {RESULTS} = TRANSLATE_MAPPING_KEY;

export const promosRewardsSection = (segmentedPlpPageData, history, localized, isMobile, onClickScroll) => {
  if (
    recursiveAndCheck(
      isEmptyObject(segmentedPlpPageData),
      segmentedPlpPageData[MENU_PLP_CONSTANT.PROMOS_REWARDS],
      !checkIfCateringPage(history.location.pathname),
    )
  ) {
    return (
      <Col
        sm={12}
        className={`plp-promo-section ${getTernaryValue(
          localized,
          'promo-section-container',
          'plp-promo-non-localized',
        )}`}
      >
        <PromosRewardsContainer
          contentData={getValueOrDefaultObject(segmentedPlpPageData[MENU_PLP_CONSTANT.PROMOS_REWARDS])}
          history={history}
          page={PLP_PAGE}
          isMobile={isMobile}
          onClickScroll={onClickScroll}
        />
      </Col>
    );
  }
};

export const mobPromosRewardsSection = (segmentedPlpPageData, history, localized, isMobile, onClickScroll) => {
  if (
    recursiveAndCheck(
      isEmptyObject(segmentedPlpPageData),
      segmentedPlpPageData[MENU_PLP_CONSTANT.PROMOS_REWARDS],
      !checkIfCateringPage(history.location.pathname),
    )
  ) {
    return (
      <Col
        className={`plp-promo-section mob-plp-col ${getTernaryValue(
          localized,
          'promo-section-container',
          'mob-plp-promo-section',
        )}`}
      >
        <PromosRewardsContainer
          contentData={getValueOrDefaultObject(segmentedPlpPageData[MENU_PLP_CONSTANT.PROMOS_REWARDS])}
          history={history}
          page={PLP_PAGE}
          isMobile={isMobile}
          onClickScroll={onClickScroll}
        />
      </Col>
    );
  }
};
export const promoRewardsClass = isCateringPage => {
  return `plp-filters ${getAndCheck(isCateringPage, 'margin-top-catering-plp')}`;
};
export const mobPromoRewardsClass = isCateringPage => {
  return `mob-plp-sections ${getAndCheck(isCateringPage, 'margin-top-mob-plp-sections')}`;
};

const CompactMenu = ({
  data,
  selectedTile,
  tenantData,
  filterList = [],
  dietaryList = [],
  sortByList = [],
  filterOptions,
  dietaryOptions,
  sortByOptions,
  handleClearItems,
  handleCheckbox,
  handleRadio,
  handleFilteredData,
  handleSearchdata,
  tempData = {},
  recommendations,
  catalogs,
  selectedCat,
  storeClosedData,
  triggerGetRecommends,
  setProductId,
  isMobile,
}) => {
  let { menu, categories, products } = getValueOrDefaultObject(data);
  if (Object.keys(tempData)?.length) {
    ({ menu, categories, products } = tempData);
  }
  const { userOrderState } = useContext(UserOrderContext);
  const [hideTopRow, setHideTopRow] = useState(false);
  const mobileSearchFilterMenuRef = useRef();
  const history = useHistory();
  const [viewCarousal, setViewCarousal] = useState(false);
  const [viewUp, setViewUp] = useState(true);
  const [carouselCount, setCarouselCount] = useState(1);
  const [recommendProducts, setReccomendedProducts] = useState([]);
  const [isSmartBannerVisible, setIsSmartBannerVisible] = useState(true);
  const [categoryStatus, setCategoryStatus] = useState(false);
  const [paramValue, setParamValue] = useState(false);
  const [activeMenuSelection, setActiveMenuSelection] = useState('');
  const [menuGtmEventTriggered, setmenuGtmEventTriggered] = useState('');
  const [inputSearchOpen, setInputSearchOpen] = useState(false);
  const [suggestedData, setsuggestedData] = useState([]);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [disclimerContent, setDisclimerContent] = useState([]);
  const filterRef = useRef(null);
  const [searchMode, setSearchMode] = useState({ isSearchedMode: false, searchedData: '' });
  const [menuTitle, setMenuTitle] = useState('');
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { localized } = useSelector(data => data.appStateReducer?.userStatus);
  const dispositionNew = getDispositionNewData(userOrderState);
  const { SEARCHOURMENU } = MENUS_PLP_CONSTANTS;
  const { category_name = '', product_name = '' } = useParams();
  const cartReducer = useSelector(cartData => cartData.cartReducer);
  const { applicableCoupons = [] } = cartReducer;
  const CustomStyledCol = useStyleScripts(STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_DESKTOP, Col);
  const CustomStyledRow = useStyleScripts(STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_MOBILE, Row);

  const params = useMemo(() => {
    return {
      tenantReducer: isEmptyObject(tenantReducer) ? tenantReducer : JSON.parse(localStorage.getItem('tenantReducer')),
      storeInfo: getTernaryValue(dispositionNew, dispositionNew?.store, {}),
      dispositionType: getTernaryValue(
        getAndCheck(dispositionNew, dispositionNew?.type),
        getDispositionTypeOnAPIFormat(dispositionNew?.type),
        getDispositionTypeOnAPIFormat(tenantReducer?.authoredContent?.defaultdisposition),
      ),
    };
  }, [dispositionNew, tenantReducer]);

  const { dispositionType } = params;

  const dispatch = useDispatch();

  useEffect(() => {
    if (getAndCheck(userOrderState?.isDeepLinkURL, categoryStatus)) {
      goToMenuPage(history);
    }
  }, [categoryStatus, userOrderState?.isDeepLinkURL, history]);

  useEffect(() => {
    dispatch(
      getContentPlpDisclaimer({
        object: getCmsClient(),
        contentFull: {
          content_type: 'supportContent',
          'fields.title': 'PLPDisclaimer',
          include: '5',
        },
      }),
    );
  }, [dispatch]);

  const PlpDisclaimerReducerData = useSelector(
    data => data.PlpDisclaimerReducerContent?.response?.plpDisclaimerResponseData || {},
  );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (PlpDisclaimerReducerData?.items?.length > 0) {
      const content = PlpDisclaimerReducerData?.items[0]?.fields.content[0]?.fields?.richText?.content;
      setDisclimerContent(content);
    }
  });

  useEffect(() => {
    let cateringOrRetailMenudata = getMenuData(history?.location?.pathname);
    setMenuTitle(cateringOrRetailMenudata.menuTitle);
  }, [history?.location?.pathname]);

  useEffect(() => {
    // Bind the event listener
    document.addEventListener(ACTIVITY_EVENTS[0], handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(ACTIVITY_EVENTS[0], handleClickOutside);
    };
  });

  useEffect(() => {
    if (data?.products?.length && searchMode?.isSearchedMode && recommendations?.length) {
      let recommentProdArr = filterRecommendations(data?.products, recommendations);
      setReccomendedProducts(recommentProdArr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchMode.searchedData, recommendations]);

  useEffect(() => {
    if (searchMode.searchedData) {
      triggerGetRecommends(searchMode.searchedData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchMode.searchedData]);

  useEffect(() => {
    const updatedCategories = changeMenulistOrder(categories);
    getCategoryAndProduct(
      updatedCategories,
      category_name,
      product_name,
      setProductId,
      setParamValue,
      setCategoryStatus,
      isMobile,
      applicableCoupons,
      history,
      onClickScroll,
      localized,
    );
    // eslint-disable-next-line
  }, [categories]);

  const onClickScroll = () => {
    const updatedCategories = changeMenulistOrder(categories);
    updatedCategories.length &&
      scroller.scrollTo(updatedCategories?.[0]?.name?.trim(), {
        duration: 1500,
        delay: 100,
        smooth: true,
        containerId: '',
        offset: getTernaryValue(isMobile, -128, -130),
      });
  };

  useEffect(() => {
    let onScrollEvent = setTimeout(() => {
      if (menuGtmEventTriggered !== activeMenuSelection) {
        const { selectedCategory, selectedSubcategory } = getCategoryFromSubCategory(menu, activeMenuSelection);
        let productList = getAnalytictsPayloadConditionaly(
          selectedCategory,
          selectedSubcategory,
          selectedCategory?.name,
          selectedCategory?.id,
          tenantData?.currencyConversionFactor,
        );
        vieItemListAnalytics(productList);
        setmenuGtmEventTriggered(() => activeMenuSelection);
      }
    }, 500);
    return () => {
      clearTimeout(onScrollEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenuSelection]);

  //mobile methods

  const handleSetActive = useCallback(
    (param, id) => {
      if (isMobile) {
        document.getElementById(`category-name-${id}`)?.scrollIntoView({ inline: 'center' });
      }
      setActiveMenuSelection(() => param);
    },
    [isMobile],
  );

  const openSearchFilterMenu = () => {
    mobileSearchFilterMenuRef.current.style.width = '100%'; // show filter modal
    setHideTopRow(true);
  };
  const setSearchModeSet = (flag, val) => {
    setSearchMode({ isSearchedMode: flag, searchedData: val });
  };

  const changeViewtoUp = useCallback(() => {
    setViewUp(true);
    setViewCarousal(false);
  }, []);

  const changeViewtoCarousal = useCallback(() => {
    setViewCarousal(true);
    setViewUp(false);
  }, []);

  const getCardCount = useCallback(count => {
    setCarouselCount(count);
  }, []);

  const scrollEventListener = () => {
    const kfcBannerImage = document?.getElementById('kfc-banner-image');
    const bounding = kfcBannerImage?.getBoundingClientRect();
    setIsSmartBannerVisible(bounding?.bottom > 2);
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollEventListener);
    return () => window.removeEventListener('scroll', scrollEventListener);
  }, [isMobile]);

  //desktop methods

  const handleClickOutside = event => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setInputSearchOpen(false);
    }
  };

  const hasSubcategoryMemoized = useCallback(subCategory => {
    hasSubcategory(subCategory);
  }, []);

  const onItemClick = useCallback(
    (event, subCategoryName, url, index) => {
      menuNavigationAnalyticsData(subCategoryName, index + 1);
      setActiveMenuSelection(() => subCategoryName);
      const element = event?.target.parentElement.querySelector('.nested');
      if (element) {
        element.classList.toggle('active-tree');
        if (event.target.classList) {
          event.target.classList.toggle('caret-down');
        }
      }
      history.push({
        pathname: getTernaryValue(
          checkIfCateringPage(history?.location?.pathname),
          `${ROUTE_URL.CATERING_PAGE}${url}`,
          `${ROUTE_URL.MENU_PAGE}${url}`,
        ),
      });
    },
    [history],
  );

  const getMenusSubcategoryMemoized = useCallback(
    (category, Link) => {
      getMenusSubcategory(category, Link, handleSetActive, onItemClick);
    },
    [handleSetActive, onItemClick],
  );

  const filteredMenu = useCallback(
    val => {
      if (products?.length > 0) {
        setsuggestedData(products.filter(obj => getAndCheck(!obj.isHidden, checkItemName(obj?.dname?.[0]?.value, val))).slice(0, 5));
      }
    },
    [products],
  );

  const clearSearch = useCallback(() => {
    setInputSearchValue('');
    setInputSearchOpen(false);
    filteredMenu('');
    handleSearchdata();
    setSearchMode({ isSearchedMode: false, searchedData: '' });
  }, [filteredMenu, handleSearchdata]);

  const filteredData = item => {
    // analytics event triggered
    setAnalyticsData(
      {
        eventType: 'suggestedSearchClick',
        selectedData: item.name,
      },
      'suggestedSearchTerm',
    );
    handleFilteredData(item.mdmId);
    setInputSearchOpen(false);
    setInputSearchValue(item.dname?.[0]?.value);
    setSearchMode({ isSearchedMode: true, searchedData: item.dname?.[0]?.value });
    window.scrollTo(0, 0);
  };

  const handleKeyPress = event => {
    if (event.key === ENTER) {
      if (event.target.value === '') {
        return;
      }
      setInputSearchOpen(false);
      handleSearchdata(event.target.value.toLowerCase().toString());
      setSearchMode({ isSearchedMode: true, searchedData: inputSearchValue });
      window.scrollTo(0, 0);
    }
  };

  const handleInput = e => {
    setInputSearchValue(e.target.value);
    if (getCheckIfAnyOnePass(filterList.length, dietaryList.length, sortByList.length)) {
      handleClearItems();
    }
    /* istanbul ignore next */
    if (e.target.value.toString().length > 2) {
      setInputSearchOpen(true);
      filteredMenu(e.target.value.toString());
    } else {
      if (inputSearchOpen) {
        /* istanbul ignore next */
        setInputSearchOpen(false);
        filteredMenu('');
        handleSearchdata();
        setSearchMode({ isSearchedMode: false, searchedData: '' });
      }
    }
  };

  //Reusable Items
  const closeSearchFilterMenuMemoized = useCallback(() => {
    closeSearchFilterMenu(filterList, dietaryList, sortByOptions, mobileSearchFilterMenuRef, setHideTopRow);
  }, [dietaryList, filterList, sortByOptions]);
  const allContentData = useSelector(dataInfo => {
    return {
      contentReducerData: get(dataInfo, 'contentReducer.response', null),
    };
  });

  const segmentedPlpPageData = getValueOrnull(getHeaderContentData(allContentData.contentReducerData));

  return (
    <React.Fragment>
      {getAndCheck(
        !userOrderState?.isDeepLinkURL,
        displaySectionWhenThereAreNoMatchingProduct(
          paramValue,
          dispositionNew,
          dispositionType,
          categoryStatus,
          storeClosedData,
          setCategoryStatus,
          history,
        ),
      )}
      {getTernaryValue(
        isMobile,
        <div className='mob-plp-au'>
          {CustomStyledRow && (
            <CustomStyledRow
              id='mob-searchinput-id'
              data-testid='mob-searchinput-id'
              isSmartBannerVisible={isSmartBannerVisible}
              topValue={document?.getElementById('select-start-order-items')?.clientHeight}
              className={`mob-nav-row ${getTernaryValue(hideTopRow, 'hide-mob-nav-row', '')}${getTernaryValue(
                localized,
                ' localized',
                '',
              )}`}
            >
              <div onClick={() => openSearchFilterMenu()} data-testid='open-search-menu' className='mob-search-input'>
                <ImageComponent srcFile={MobSearchIcon} className='mob-search-img' alt='' />
                {getAndCheck(
                  getAndCheckIfOneTrue([...filterList, ...dietaryList].length, searchMode.isSearchedMode),
                  <div className='totalFilterAppliedCount'>{filterNotHiddenProducts(products)}</div>,
                )}
              </div>
              <NavigationItems
                filterList={filterList}
                dietaryList={dietaryList}
                sortByList={sortByList}
                searchMode={searchMode}
                isMobile={isMobile}
                clearSearch={clearSearch}
                handleClearItems={handleClearItems}
                menu={menu}
                categories={categories}
                setActiveMenuSelection={setActiveMenuSelection}
                history={history}
                hasSubcategory={hasSubcategoryMemoized}
                handleSetActive={handleSetActive}
                getMenusSubcategory={getMenusSubcategoryMemoized}
                onItemClick={/* istanbul ignore next */ onItemClick}
              />
            </CustomStyledRow>
          )}
          <SearchItems
            searchMode={searchMode}
            filterList={filterList}
            dietaryList={dietaryList}
            isMobile={isMobile}
            products={products}
          />
          <Row className='mob-plp-sections'>
            {mobPromosRewardsSection(segmentedPlpPageData, history, localized, isMobile, onClickScroll)}
          </Row>
          <Row className={mobPromoRewardsClass(checkIfCateringPage(history?.location?.pathname))}>
            <MenuItems
              isMobile={isMobile}
              searchMode={searchMode}
              categories={categories}
              viewCarousal={viewCarousal}
              viewUp={viewUp}
              changeViewtoUp={changeViewtoUp}
              changeViewtoCarousal={changeViewtoCarousal}
              carouselCount={carouselCount}
              tenantData={tenantData}
              recommendProducts={recommendProducts}
              localized={localized}
              catalogs={catalogs}
              storeClosedData={storeClosedData}
              selectedCat={selectedCat}
              getCardCount={getCardCount}
              filterList={filterList}
              dietaryList={dietaryList}
              products={products}
              clearSearch={clearSearch}
              dispositionType={dispositionType}
            />
            {getAndCheckIfAllPass(
              isSupportedTenantCode(),
              PlpDisclaimerReducerData,
              <div className='mob-disclimer-content'>
                {disclimerContent?.map((item, i) => {
                  const arrLength = disclimerContent?.length;
                  return (
                    <div
                      key={`disclaimer-${i}`}
                      className='info-content-mobile'
                      id={getTernaryValue(arrLength === i + 1, 'lastElement-disclimer', '')}
                      dangerouslySetInnerHTML={{
                        __html: documentToHtmlString(item),
                      }}
                    />
                  );
                })}
              </div>,
            )}
          </Row>
          <MobSearchFilterMenu
            ref={mobileSearchFilterMenuRef}
            className='sidenav-filter'
            selectedTile={selectedTile}
            filterList={filterList}
            dietaryList={dietaryList}
            sortByListMob={sortByList}
            filterOptions={filterOptions}
            dietaryOptions={dietaryOptions}
            sortByOptions={sortByOptions}
            handleCheckbox={handleCheckbox}
            handleClearItems={handleClearItems}
            handleRadio={handleRadio}
            closeSearchFilterMenu={closeSearchFilterMenuMemoized}
            tempData={tempData}
            data={data}
            inputSearchData={inputSearchValue}
            handleFilteredData={handleFilteredData}
            handleSearchdata={handleSearchdata}
            setSearchModeData={setSearchModeSet}
          />
        </div>,
        <Row className='plp-menu-row' data-testid='menus-container'>
          {CustomStyledCol && (
            <CustomStyledCol
              md='3'
              className={`plp-left-nav plp-side-panel${getTernaryValue(localized, ' localized', '')}`}
            >
              <Row className='plp-stripes-section'>
                <ImageComponent srcFile={StripesIcon} className='stripes-img' alt='' />
              </Row>

              {/*Line number 543 updated.Reference Jira RENDEV-16664*/}
              <DynamicHeadings
                className='kfc-menu-title'
                value={getTernaryValue(
                  getAndCheckIfOneTrue([...filterList, ...dietaryList].length, searchMode.isSearchedMode),
                  `${filterNotHiddenProducts(products)} ${translateWithI18Next(RESULTS)}`,
                  menuTitle,
                )}
              />

              <NavigationItems
                filterList={filterList}
                dietaryList={dietaryList}
                sortByList={sortByList}
                searchMode={searchMode}
                isMobile={isMobile}
                clearSearch={clearSearch}
                handleClearItems={handleClearItems}
                menu={menu}
                categories={categories}
                setActiveMenuSelection={setActiveMenuSelection}
                history={history}
                hasSubcategory={hasSubcategoryMemoized}
                handleSetActive={handleSetActive}
                getMenusSubcategory={getMenusSubcategoryMemoized}
                onItemClick={onItemClick}
              />
            </CustomStyledCol>
          )}
          <Col md='9' className='plp-right-nav'>
            {promosRewardsSection(segmentedPlpPageData, history, localized, isMobile, onClickScroll)}
            <Col sm={12} className={promoRewardsClass(checkIfCateringPage(history?.location?.pathname))}>
              <div data-testid='menu-search-testid' className='search-menu'>
                <InputBox
                  name='searchInput'
                  className='search-menu-input'
                  onKeyPress={e => handleKeyPress(e)}
                  onChange={e => handleInput(e)}
                  value={inputSearchValue}
                  placeholder={translateWithI18Next(SEARCHOURMENU)}
                  aria-label='Search our menu'
                  onBlur={event => (event.target.placeholder = `${translateWithI18Next(SEARCHOURMENU)}`)}
                />
                <span className='search-icon'>
                  <ImageComponent srcFile={SearchIcon} className='search-icon-img' alt='' />
                </span>
                {getTernaryValue(
                  getAndCheckIfOneTrue(
                    getAndCheck(inputSearchValue.length > 2, !searchMode.isSearchedMode),
                    getAndCheck(
                      getAndCheck(inputSearchValue.length > 2, searchMode.isSearchedMode),
                      getAndCheckIfOneTrue(
                        filterNotHiddenProducts(getValueOrnull(products)) > 0,
                        filterNotHiddenProducts(getValueOrnull(products)) === 0,
                      ),
                    ),
                  ),
                  <img
                    className='input-dark-cross'
                    data-testid='clear-all-input'
                    onClick={() => clearSearch()}
                    src={DarkCloseButton}
                    alt=''
                  />,
                  null,
                )}
                {getAndCheck(
                  inputSearchOpen,
                  <div ref={filterRef} className='inputAutoCompletePLP'>
                    {suggestedData?.length > 0 && (
                      <div>
                        <div className='SuggestionHeader'>
                          {' '}
                          {translateWithI18Next(SEARCH_STORE_CONSTANTS.SUUGESTED_ITEMS_TEXT)}
                        </div>
                        <ul className='autoCompleteListPLP'>
                          {suggestedData.map((item, index) => (
                            <li
                              onClick={() => filteredData(item)}
                              key={item.mdmId + index}
                              data-testid={`suggestion-click-${item.name}`}
                              className='wrapperAutoCompletePLP'
                            >
                              <span className='searchgrey-icon-img'>
                                <ImageComponent srcFile={SearchIconGrey} alt='' />
                              </span>
                              <span>{item.dname?.[0]?.value}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>,
                )}
              </div>
            </Col>
            <SearchItems
              searchMode={searchMode}
              filterList={filterList}
              dietaryList={dietaryList}
              isMobile={isMobile}
              products={products}
            />
            <Row
              className={getTernaryValue(
                getCheckIfAnyOnePass(searchMode.isSearchedMode, filterList.length > 0, dietaryList.length > 0),
                '',
                'plp-sections',
              )}
            >
              <MenuItems
                isMobile={isMobile}
                searchMode={searchMode}
                categories={categories}
                viewCarousal={viewCarousal}
                viewUp={viewUp}
                changeViewtoUp={changeViewtoUp}
                changeViewtoCarousal={changeViewtoCarousal}
                carouselCount={carouselCount}
                tenantData={tenantData}
                catalogs={catalogs}
                storeClosedData={storeClosedData}
                selectedCat={selectedCat}
                getCardCount={getCardCount}
                filterList={filterList}
                dietaryList={dietaryList}
                products={products}
                clearSearch={clearSearch}
                recommendProducts={recommendProducts}
                localized={localized}
                dispositionType={dispositionType}
              />
            </Row>
            {getAndCheckIfAllPass(
              isSupportedTenantCode(),
              PlpDisclaimerReducerData,
              <div className='info-content'>
                {disclimerContent?.map((item, index) => {
                  return (
                    <div
                      key={`some-disc-${index}`}
                      dangerouslySetInnerHTML={{
                        __html: documentToHtmlString(item),
                      }}
                    />
                  );
                })}
              </div>,
            )}
          </Col>
        </Row>,
      )}
    </React.Fragment>
  );
};

export const CompactMenuItem = React.memo(CompactMenu);
